module.exports = __webpack_public_path__ + "static/media/logo.4d1528a3.jpg";